import { bffApi } from "../../autogen/bff-api";
import { isNoAccessError } from "../../common/errors/isNoAccessError";
import { fetchFresh } from "../../common/redux/fetchFresh";
import type { AppDispatch } from "../../common/redux/store";

export interface OrganizationRef {
  id: string;
  name: string;
}

export type EventAccess = "open" | "denied" | "failed";

export type EventAccessProbe = (eventId: string, organizationId: string) => Promise<EventAccess>;

export const buyerEventAccessProbe =
  (dispatch: AppDispatch): EventAccessProbe =>
  async (eventId, organizationId) => {
    try {
      await fetchFresh(
        dispatch(
          bffApi.endpoints.getSourcingEvent.initiate(
            { eventId, organizationId, recordView: false },
            { forceRefetch: true },
          ),
        ),
      );
      return "open";
    } catch (e) {
      return isNoAccessError(e) ? "denied" : "failed";
    }
  };

export interface OpenableOrganizations {
  openable: OrganizationRef[];
  anyProbeFailed: boolean;
}

export const organizationsThatCanOpen = async (
  eventId: string,
  candidates: OrganizationRef[],
  probe: EventAccessProbe,
): Promise<OpenableOrganizations> => {
  const verdicts = await Promise.all(
    candidates.map((org) => probe(eventId, org.id).catch((): EventAccess => "failed")),
  );
  return {
    openable: candidates.filter((_, index) => verdicts[index] === "open"),
    anyProbeFailed: verdicts.includes("failed"),
  };
};
